import type { MethodLogo } from './types';

/**
 * The logo strip on the right of a payment row.
 *
 * Each logo sits in a fixed 35×24 bordered tile with the mark inset at its own intrinsic size —
 * the mark never fills or stretches to the tile, so brands with different proportions stay
 * correct. Same tile geometry as `CardBrandTile` in `profile/payment/card-brands.tsx` (Figma node
 * 2364:69688), which the payment rows in node 1716:92988 reuse.
 *
 * A logo with `width: 0` is CMS-authored and has no measured geometry, so it is sized by height and
 * lets the browser derive the width.
 */
export function MethodLogos({ logos }: { logos: MethodLogo[] }) {
  if (logos.length === 0) return null;

  return (
    <div className="flex shrink-0 items-center gap-1">
      {logos.map(logo => (
        <div
          key={logo.src}
          className="flex h-6 w-[35px] shrink-0 items-center justify-center rounded-[4px] border border-solid border-[#d9d9d9]"
          style={{ backgroundColor: logo.background ?? '#ffffff' }}
        >
          <img
            src={logo.src}
            alt={logo.alt}
            style={
              logo.width > 0
                ? { width: logo.width, height: logo.height }
                : { height: logo.height, width: 'auto', maxWidth: '31px' }
            }
          />
        </div>
      ))}
    </div>
  );
}
